import Label from "Components/Common/components/Label";
import Create from "Components/GMS/Pdw/upload/Create";
import React from "react";
import { Modal } from "react-bootstrap";
// @todo remove bootstrap modal
const CreatePDW = (props) => {
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={props?.showCreatePopup}
      onHide={props?.modalCreateClose}
    >
      <Modal.Header closeButton>
        <div>
          <Label
            message={"Upload XLS - Create"}
            fontSize={0.875}
            fontWeight="600"
          />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="m-2">
            <div className="row">
              <Create
                modalCreateClose={props?.modalCreateClose}
                load_Products_By_Category={props.fetchData}
                fromProduct={true}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreatePDW;
